export default __webpack_public_path__ + "static/media/131.c8612014.jpg";